export default "__VITE_PUBLIC_ASSET__cba1a3b2__"